import { Button, Group, Text } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { WorkspaceItem } from "./WorkspaceItem";
import classes from "./WorkspaceDashboard.module.css";

export function WorkspaceList({
  workspaces,
  selectedWorkspaceId,
  onSelectWorkspace,
  isAdmin,
}) {
  const navigate = useNavigate();

  return (
    <>
      <Group justify="space-between" mb="lg">
        <Text fw={700} size="xl">
          Workspaces
        </Text>
        {isAdmin && (
          <Button
            variant="light"
            size="xs"
            leftSection={<IconPlus size={16} />}
            onClick={() => navigate("/app/workspaces/create")}
          >
            Add Workspace
          </Button>
        )}
      </Group>

      <div className={classes.workspaceScroll}>
        {workspaces?.map((ws) => (
          <WorkspaceItem
            key={ws.id}
            ws={ws}
            isActive={selectedWorkspaceId === ws.id}
            onSelect={onSelectWorkspace}
            isAdmin={isAdmin}
          />
        ))}
      </div>
    </>
  );
}
